import React, { useEffect, useState } from 'react'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomCards from '../Components/CustomCards/CustomCards'
import CustomTable from '../Components/CustomTable/CustomTable'
import CustomPagination from '../Components/CustomPagination/CustomPagination'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Col, Container, Nav, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchStudents } from '../hooks/students'
import { fetchAdminweeks } from '../hooks/week'
import { fetchAdminOrders } from '../hooks/order'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function Orders() {
  const dispatch = useDispatch()
  const { list } = useSelector((state) => state.students);
  const [viewMode, setViewMode] = useState("day");
  const { list: weekList } = useSelector((state) => state.week);
  const { list: orders } = useSelector((state) => state.order);
    const trainees = orders?.trainees?.items || [];

    const { list:resturants, Pagination } = useSelector((state) => state.resturants);
  const [selectedRestaurant, setSelectedRestaurant] = useState("all");
  const traineesData = trainees.filter((t) => {
  if (selectedRestaurant === "all") return true;
  return t.restaurant_id == selectedRestaurant;
});
  const countMealsByDay = (mealId, day) => {
    return traineesData.filter((t) => {
      const meals = t.days?.[day] || [];
      return meals.includes(mealId);
    }).length;
  };

  const [selectedDate, setSelectedDate] = useState(new Date());
  
  const dayKey = selectedDate
    .toLocaleDateString('en-US', { weekday: 'short' })
    .toLowerCase();
  const countMeals = (mealId) =>
    traineesData.filter((t) => {
      if (viewMode === "day") {
        return (t.days?.[dayKey] || []).includes(mealId);
      }
      return days.some((day) =>
        (t.days?.[day] || []).includes(mealId)
      );
    }).length;

  const todayAr = selectedDate.toLocaleDateString('ar-EG', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const dayMap = {
    sat: "السبت",
    sun: "الأحد",
    mon: "الاثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
  };
  const days = ["sat", "sun", "mon", "tue", "wed", "thu", "fri"];


  const today = new Date();

  const currentWeek = weekList.find(week => {
    const start = new Date(week.start_date);
    const end = new Date(week.end_date);

    return today >= start && today <= end;
  });

  console.log(currentWeek, "currentWeek");

  useEffect(() => {
    dispatch(fetchStudents());
    dispatch(fetchAdminweeks());
  }, [dispatch]);

  useEffect(() => {
    if (weekList.length > 0) {
      const today = new Date();

      const currentWeek = weekList.find(week => {
        const start = new Date(week.start_date);
        const end = new Date(week.end_date);
        return today >= start && today <= end;
      });

      if (currentWeek) {
        dispatch(fetchAdminOrders(currentWeek.id));
      }
    }
  }, [weekList, dispatch]);
  // const header = [
  //   "المستفيد",


  //   "فطور",
  //   "غداء",
  //   "عشاء"
  // ]
  const customheader = <thead>
    {viewMode === "day" ?
      <tr>
        <th>المستفيد</th>
        <th>رقم العسكري</th>

        <th>اسم المطعم</th>
        <th>فطور ({countMeals(10)} طالب)</th>
        <th>غداء ({countMeals(11)} طالب)</th>
        <th>عشاء ({countMeals(12)} طالب)</th>

      </tr>
      :
      <tr>
        <td><strong>المستفيد</strong></td>
        <td><strong>رقم العسكري</strong></td>

        {viewMode === "week" &&
          days.map((day) => (
            <th key={day} colSpan={3}>

              {dayMap[day]}
            </th>
          ))}
      </tr>
    }
    {viewMode === "week" && (
      <tr>
        <td></td>
        <td></td>


        {days.map((day, index) => {
          const isLast = index === days.length - 1;

          return (
            <React.Fragment key={day}>
              <th>فطور ({countMealsByDay(10, day)} طالب)</th>
              <th> غداء ({countMealsByDay(11, day)} طالب)</th>
              <th className={!isLast ? "day-separator" : ""}>عشاء ({countMealsByDay(12, day)} طالب)</th>
            </React.Fragment>
          )
        })}
      </tr>
    )}

  </thead>


  const body = (
    <tbody>
      {traineesData.map((t, index) => {

        // 🟢 يومي
        if (viewMode === "day") {
          const meals = t.days?.[dayKey] || [];
console.log(t);

          return (
            <tr key={t.id}>
              <td>{t.name}</td>
              <td>{t?.military_number}</td>
              <td>{resturants.find((item)=>item?.id==t?.restaurant_id)?.name}</td>
              <td>{meals.includes(10) ? "✔️" : "❌"}</td>
              <td>{meals.includes(11) ? "✔️" : "❌"}</td>
              <td>{meals.includes(12) ? "✔️" : "❌"}</td>
            </tr>
          );
        }

        if (viewMode === "week") {
          const allDays = t.days || {};
          const isLast = index === days.length - 1;

          return (
            <tr key={t.id}>
              <td>{t.name}</td>
              <td>{t?.military_number}</td>

              {days.map((day) => {
                const meals = allDays[day] || [];

                return (
                  <React.Fragment key={day}>
                    <td>{meals.includes(10) ? "✔️" : "❌"}</td>
                    <td>{meals.includes(11) ? "✔️" : "❌"}</td>

                    <td className={!isLast ? "day-separator" : ""}>
                      {meals.includes(12) ? "✔️" : "❌"}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>
          );
        }

      })}
    </tbody>
  );

const downloadExcel = () => {
  const data = traineesData.map((t) => {
    if (viewMode === "day") {
      const meals = t.days?.[dayKey] || [];

      return {
        الاسم: t.name,
        رقمالعسكري: t?.military_number,
        المطعم: resturants.find(r => r.id == t.restaurant_id)?.name,
        فطور: meals.includes(10) ? "نعم" : "لا",
        غداء: meals.includes(11) ? "نعم" : "لا",
        عشاء: meals.includes(12) ? "نعم" : "لا",
      };
    }

    // week mode
    const row = {
      الاسم: t.name,
              رقمالعسكري: t?.military_number,

    };

    days.forEach((day) => {
      const meals = t.days?.[day] || [];

      row[`${dayMap[day]} - فطور`] = meals.includes(10) ? "✔️" : "❌";
      row[`${dayMap[day]} - غداء`] = meals.includes(11) ? "✔️" : "❌";
      row[`${dayMap[day]} - عشاء`] = meals.includes(12) ? "✔️" : "❌";
    });

    return row;
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(file, "orders.xlsx");
};
  return (
    <div>
      <AuthNavbar />
      <Container>
        <CustomHeader
          title={"الالتحاق بالأكاديمية"}
          subtitle={""}
          downloadData={true}
          downloadFunction={downloadExcel}
          addData={false}
          status={"student"}


        />
        {/* <CustomCards
          data={data}
        /> */}
        <Row>
          <Col md={3}>
  <select
    className="form-control"
    value={selectedRestaurant}
    onChange={(e) => setSelectedRestaurant(e.target.value)}
  >
    <option value="all">كل المطاعم</option>
    {resturants.map((r) => (
      <option key={r.id} value={r.id}>
        {r.name}
      </option>
    ))}
  </select>
</Col>
          {viewMode === "day" &&
            <Col md={3}>
              <DatePicker
                  className="form-control"

                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
              />

            </Col>
          }
          <Col md={6}>
            <Nav variant="pills" className="mb-3">
              <Nav.Item>
                <Nav.Link
                  active={viewMode === "day"}
                  onClick={() => setViewMode("day")}
                >
                  يومي
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  active={viewMode === "week"}
                  onClick={() => setViewMode("week")}
                >
                  أسبوعي
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
        </Row>
        <Row>
          <Col md={5}>
            <div >
              <strong>
                {viewMode === "day"
                  ? `وجبات يوم ${todayAr}`
                  : "وجبات الأسبوع الحالي"}
              </strong>
            </div>
          </Col>

        </Row>

        <CustomTable
          data={list}
          fiteration={[]}
          currentData={25}
          allData={' 1,248  مستفيد'}
          customheader={customheader}
          status={"student"}
          body={body}

        />
        <CustomPagination
          currentData={25}
          allData={list?.length}

        />
      </Container>
    </div>
  )
}

export default Orders